
export function ConcatOfficeDisplayName(target: any, ids: string[]) {
    let displayName = ids.map(id => $('#' + id).val()).filter(Boolean).join(" ");
    $(target).val(displayName)
}

jQuery(() => {
    $('[data-update-officedn-from]').each((idx, elem) => {
        let ids: string[] = $(elem).data('update-officedn-from').split(',');

        for (var id in ids) {
            $('#' + ids[id]).change(() => ConcatOfficeDisplayName(elem, ids));
        }
    });
});
